import { Component, OnInit } from '@angular/core';
import { CarService } from '../demo/service/carservice';
import { EventService } from '../demo/service/eventservice';
import { Car } from '../demo/domain/car';
import { SelectItem } from 'primeng/primeng';
import { MenuItem } from 'primeng/primeng';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { BreadcrumbService } from 'src/app/shared/dashboard-layout/breadcrumb.service';
import { AcademicService } from '../component/Academic/academic.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']


})
export class DashboardDemoComponent implements OnInit {

    //CHARTS
    lineData: any;

    barData: any;

    pieData: any;

    polarData: any;

    radarData: any;
    roleId:any;



    cities: SelectItem[];

    cars: Car[];

    cols: any[];

    chartData: any;

    events: any[];

    selectedCity: any;

    selectedCar: Car;

    items: MenuItem[];

    fullcalendarOptions: any;
    employeeId: any;
    academic_TimeTableList: any;
    dashboardSummaryData: any;
    registered: any;
    compltedApplication: any;
    uncompletedApplication: any;
    enrolled: any;
    offerLetter: any;

    constructor(private carService: CarService, private loadingService: NgxSpinnerService, private eventService: EventService,private service: AcademicService, private breadcrumbService: BreadcrumbService) {
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: ['/main/dashboard'] }
        ]);
    }

    ngOnInit() {
       
        this.cols = [
            { field: 'time', header: 'Time' },
            { field: 'sunday', header: 'Sunday' },
            { field: 'monday', header: 'Monday' },
            { field: 'tuesday', header: 'Tuesday' },
            { field: 'wednesday', header: 'Wednesday' },
            { field: 'thursday', header: 'Thursday' },
            { field: 'friday', header: 'Friday' },
            { field: 'saturday', header: 'Saturday' },
          ];
          
       this.roleId =  this.convertToNumber(localStorage.getItem('idr'));
       this.employeeId =  this.convertToNumber(localStorage.getItem('idu'));

        this.eventService.getEvents().then(events => { this.events = events; });

        this.fullcalendarOptions = {
            plugins: [ dayGridPlugin, timeGridPlugin, interactionPlugin ],
            defaultDate: '2016-01-12',
            header: {
                right: 'prev,next, today',
                left: 'title'
            }
        };

        this. get_ProgrammeTimeTable();
        this.dashboardSummary();
    }

    convertToNumber(pamount) {

        if (typeof (pamount) == "string") {
            return pamount = pamount.replace(/[^0-9-.]/g, '');
        } else if (typeof (pamount) == "number") {
            return pamount = pamount;
        }
    
    }

    dashboardSummary() {
        let data ={
          employeeId: this.employeeId,
          academicSemesterId:1,
          academicSessionId:2
        }
    
        this.loadingService.show();
        this.service.dashboardSummary().subscribe((result: any) => {
          if (result.success == true) {
            this.dashboardSummaryData = result.response[0];
            
            this.registered = this.dashboardSummaryData.registered;
            this.compltedApplication = this.dashboardSummaryData.compltedApplication;
            this.uncompletedApplication = this.dashboardSummaryData.uncompletedApplication;
            this.enrolled = this.dashboardSummaryData.enrolled;
            this.offerLetter = this.dashboardSummaryData.offerLetter;
            this.loadingService.hide();
          }
        },
          error => {this.loadingService.hide(); })
      }

    get_ProgrammeTimeTable() {
        let data ={
          employeeId: this.employeeId,
          academicSemesterId:1,
          academicSessionId:2
        }
    
        this.loadingService.show();
        this.service.get_ProgrammeTimeTableFaculty(data).subscribe((result: any) => {
          if (result.success == true) {
            this.academic_TimeTableList = result.response;
            this.loadingService.hide();
          }
        },
          error => {this.loadingService.hide(); })
      }
    
}
